module.exports = __webpack_public_path__ + "static/media/icon_arrow_right_white.26341657.svg";